import { observable, action } from "mobx";

export class ScrollStore {
  @observable accessor isVisible = false;

  constructor() {
  }

  @action
  setIsVisible(visible) {
    this.isVisible = visible;
  }
}

const scrollStore = new ScrollStore();

export default scrollStore;
